import type {
  RectificationCandidateOut,
  RectificationEventInput,
  RectificationEventMatch,
  RectificationEventType,
  RectificationRequest,
  RectificationResponse,
} from "@ishvaram/api-client";

export type {
  RectificationCandidateOut,
  RectificationEventInput,
  RectificationEventMatch,
  RectificationEventType,
  RectificationRequest,
  RectificationResponse,
};
import { apiRequest } from "./_fetch";

/**
 * Rank candidate birth minutes for an uncertain birth window.
 *
 * The response is a ranking, never a verified birth time — render its
 * `boundary` alongside the candidates (rule 29).
 */
export async function rectifyBirthTime(
  data: RectificationRequest
): Promise<RectificationResponse> {
  return apiRequest<RectificationResponse>("/rectification", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}
